// These are objects and constants used by canvas code, that are best in .ts file instead of .js file
// Includes definitions of jsonFile math data as created by canvas
// Other developers - please don't add to or change this file
// canvas/angular API is defined by canvasSymTypes.ts
// canvas/draw tool API is defined by draw-tool-api.ts


import { STATE_NORMAL } from 'src/assets/js/cv-classes.js';
import { stage } from 'src/assets/js/draw.js';
import {DrawToolType} from 'src/app/shared/constant/draw-tool-api';
import {db} from 'src/assets/js/draw.js';

// Classes and constants used by the canvas drawing board section to define 
// math data into a file a file structure to be saved on the host

// length and width in pixels of each canvas page, used to size multi-page pdfs and user entry
export const ONE_PAGE_LENGTH = 1123;
export const ONE_PAGE_WIDTH = 796;
export const PAGE_MAX_PROB_START_POS = 1023;  // y position of location that new page will be added
export const STAGE_MIN_WIDTH = 100;

// constants for use to pass into cNewFile call to indicate if analytics should be gathered 
export const CV_ANALYTICS_NONE = 0;   // keep this value to be equivalent to false
export const CV_ANALYTICS_BASIC = 1;
export const CV_ANALYTICS_ADVANCED = 2;

// Math levels 1-2 use grid type displays, levels 3-4 use primarily line type display
export const DISPLAY_TYPE_GRID = 1;
export const DISPLAY_TYPE_LINE = 2;
export const DISPLAY_TYPE_TEXT = 5;

export const FS_REG = 1;
export const FS_MED = 2;
export const FS_SMALL = 3;

// default starting x and y positions for new files, first problem.  User can change positions by clicking on stage
export const START_XPOS = 50;
export const START_YPOS = 50;

// An imported image passed in with the new file can have types of pdf of bitmap (.jpg/.png)  
// None indicates no imported file
export const IMAGE_TYPE_NONE = 0;
export const IMAGE_TYPE_PDF = 1;
export const IMAGE_TYPE_BITMAP = 2;

// Font size constants from user preferences, default is large
export const FONT_SIZE_SM = 0;
export const FONT_SIZE_MED = 1;
export const FONT_SIZE_LG = 2;
export const FONT_SIZE_XLG = 4;

export const SCALE_DOT_SIZE = 5;                        // size in pixels of circle dots at corners of scaling box
export const LINE_DOT_SIZE = 5;                         // size in pixels of circle dots at ends of line segments
export const SCALE_BOX_COLOR = "green";
export const PROBLEM_BACKGROUND_COLOR = "ghostwhite";   // color of the background for grid problems, alpha is applied
export const STAGE_BACKGROUND_COLOR = "white";
export const PROBLEM_GRID_COLOR = 'gray';               // color of the grid lines drawn on grid problems
export const LINE_COLOR = "black"; //green";
export const CURSOR_COLOR = "#addfad"; //  "khaki";    //  color of cursor when in normal state  "cornsilk";


export const EQUALS_PREFS_COLOR = "red";
export const OPERATORS_PREFS_COLOR = "#6699CC"
export const NEG_PREFS_COLOR = "red";
export const ABC_BOX_ACTICE_COLOR = "green";
export const ABC_BOX_ACTIVE_STROKE = 0.5;
export const ABC_BOX_INACTIVE_STROKE = 0.2;
export const ABC_BOX_INACTICE_COLOR = "gray";


export const NO_DATA_TO_SAVE = 0;                       // indicates no data has changed since last file - might not be using
export const UNITS_GRID_SCALE = 0.7;                    // scaling size for fonts of units on level 1/2 to fit into a grid
export const MPROB_NEW_LINE = "<NL>";                   // marker put in save files to indicate new line in grid problem
export const FULL_CANVAS = "full";                      // saved on images and background, identifies full canvas for stage new clicks vs bubbled clicks
export const CREATEJS_NAME_LINE = "line";               // shape containing line segment
export const CREATEJS_NAME_LINE_DOT = "LineDot";        // shape containing scaling dot for end of line segments
export const CREATEJS_NAME_DIVIDE = "divide";           // shape containing long divide
export const CREATEJS_NAME_CARRY_TEXT = "carryText";    // text containing digits for carry
export const CREATEJS_NAME_CARRY_BOX = "carryBox";      // shape containing highlight box for carry digits
export const CREATEJS_NAME_ABC_TEXT = "ABCText";        // container for ABC text
export const CREATEJS_NAME_IMPORT_FILE = "ImportFile";  // container for the import files
export const CREATEJS_NAME_LINE_DOT_START = "LineDotStart";  // shape containing the starting dot for the start of line segments
export const START_LINESEG_DOT = 1;
export const END_LINESEG_DOT = 2;


// The mathFileType object contains a copy of the user data to save to the host
// It has some header elements that relate to the whole file,  and then
//  an array of elements of type MathFileProbType as defined below, to represent 
// user data 

export class MathFileProbType {
    type: string; x: number; y: number; pScale: number;
    font: number; fontIndex: number; gridW: number; gridH: number; width: number; data: string[];

    constructor(type: string, x: number, y: number, pScale: number, font: number, fontIndex: number, gridW: number, gridH: number, width: number) {
        this.type = type;
        this.x = x;
        this.y = y;
        this.pScale = pScale;
        this.font = font;   // font size
        this.fontIndex = fontIndex;
        this.gridW = gridW;
        this.gridH = gridH;
        this.width = width;
        this.data = [];
    }
}

export class MathFileType {mathLevel:number; stageScale:number; imageType:number;
                           imageScale:number; pageCount:number; version:number; 
                           problemCount:number; 
                           timeSpent:number; excessErrors: number;   
                           mathProblem:MathFileProbType[];
                           whiteSpaceSplits: WhiteSpaceSize[]; savedPenItem: MathFilePenItem[];
                           userLog: UserInputLog | null = null;
    constructor (mathLevel:number,stageScale:number,imageType:number,imageScale:number) {
        this.mathLevel = mathLevel;
        this.stageScale = stageScale;
        this.imageType = imageType;
        this.imageScale = imageScale;
        this.pageCount = 1;
        this.version = 3.0;
        this.problemCount = 0;      // total number of problems in file
        this.timeSpent =  -1;       // active time spent in minutes - initial temp value set for angular teting
        this.excessErrors = -1;      // in percentage out of 100  (5 = 5% as initial test value), measure frequency of user excess use of delete/undo
        this.mathProblem = []; 
        this.whiteSpaceSplits = []; 
        this.savedPenItem = [];  
        this.userLog = null;    
    }
}

export class MathFileSpecSym {
    symType: number; size1: number; size2: number; value: string; flag: boolean; value2: string;
    constructor(symType: number, size1: number, size2: number, value: string, flag: boolean, value2: string) {
        this.symType = symType;         // use symConst types for this or fraction KEY_ID_FRACION_GRID_SIGN
        this.size1 = size1;         // size1 = start grid nbr in line, w in text
        this.size2 = size2;           // grid position line/division ends, h in text
        this.value = value;         // used for grid fraction numerator strings
        this.flag = flag;          // wrapped = true in text
        this.value2 = value2;       // used for grid fraction denominator strings
    }
}

export class cvPointType {x:number; y:number;
    constructor(x:number,y:number) {
        this.x = x;
        this.y = y;
    }
}
export const ZERO_PT = new cvPointType(0,0);

export class MathFilePenItem {
    //x: number; y: number; dt: DrawToolType; points: cvPointType[]; 
    //constructor(x: number, y: number, dt: DrawToolType) {
       x: number; y: number; offsetX: number; offsetY: number; dt: DrawToolType; radius: number; width: number; height: number; points: cvPointType[]; 
    constructor(x: number, y: number, dt: DrawToolType) {
   
        this.x = x;                 // x position on file background coordinates
        this.y = y;                 // y position on file background coordinates
        this.dt = dt;               // draw tool attributes from sideboard
        this.offsetX = 0;           // offset from pen Item moves
        this.offsetY = 0;           // offset from pen item moves
        this.radius = 0;            // radius for circles
        this.width = 0;              // width for shapes
        this.height = 0;              // height for shapes
        this.points = [];            // point array of points of pen item.  Freehand items will have long list
    }

    copyPenPoints(penItem:PenItemType) {
        let nextPoint;
        for (let i=0; i < penItem.points.length; i++) {
            nextPoint = new cvPointType(penItem.points[i].x, penItem.points[i].y)
            this.points.push(nextPoint);
        }

    }

    clonePen() {
        this.dt = Object.assign({}, db.pen);
    }

    copyForFileSave(penItem:PenItemType) {
       // console.log("In copy", penItem);
        this.dt = Object.assign({}, penItem.dt);              // draw tool attributes from sideboard
        this.x = penItem.x;                 // x position on file background coordinates
        this.y = penItem.y;                 // y position on file background coordinates
        this.offsetX = penItem.container.x;  // offset from moves, saved in container coordinates
        this.offsetY = penItem.container.y;
        this.radius = penItem.radius;       // radius for circles
        this.width = penItem.width;         // width for shapes
        this.height = penItem.height;       // height for shapes
        this.copyPenPoints(penItem);
    
    }

    // initialize when addding new pen item into db structure from current values of pen tool
    initPenItem(penPt:any) {
       
        //this.points.push(penPt);
        this.clonePen();
        this.x = penPt.x;
        this.y = penPt.y;
        db.penItemList.push(this);
    }

    popPenItem() {
        db.penItemList.pop;
      }

    // initialize when addding new pen item into db structure from current values of pen tool
    initFromFilePenItem(penPt:any, savedPenSettings: DrawToolType) {
       
        //this.points.push(penPt);
        this.dt = Object.assign({}, savedPenSettings);
        this.x = penPt.x;
        this.y = penPt.y;
        db.penItemList.push(this);
    }
}


export class PenItemType extends MathFilePenItem {myIndex: number; deleted: boolean; state: number; container: any; shape: any; startLineObj: any; 
    endLineObj: any; pointsObj: any[]; jointsObj: any[]; pointsVisible: boolean; backgroundObj: any; tempLine: any; 
      
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    constructor(x: number, y: number, dt: DrawToolType, radius: number, width: number, height: number) {
        super(x, y, dt);  
        this.myIndex = -1;
        this.deleted = false;
        this.state = STATE_NORMAL_PEN_ITEM;
        this.container = null; 
        this.shape = null;          // createjs object for main shape
        this.startLineObj = 0;      // createjs object for line start shape
        this.endLineObj = 0;        // createjs object for line end shape
        this.pointsObj = [];        // createjs object for points dots used for edit dragging 
        this.jointsObj = [];         // createjs object for joint dots when selected on multiLine
        this.pointsVisible = false;  // show dots at end points for editing 
        this.backgroundObj = null;   // createjs object for background object to draw during edit moves to provide selection area
        this.tempLine = null;        // temporary createjs line shape for multiLines to show postion relative to cursor
    }

}

export const STATE_NORMAL_PEN_ITEM = 1;
export const STATE_DRAW_PEN_ITEM = 2;
export const STATE_EDIT_PEN_ITEM = 3;
export const STATE_EDIT_PT_AFTER_CREATE = 4;

export const UNDO_TYPE_FILE = "SaveFile";
export const UNDO_TYPE_WHITESPACE = "UndoWhiteSpace";

export class undoStackBranch {
    parentIndex: number; branchIndex: number;
    constructor(parentIndex: number, branchIndex: number) {
        this.parentIndex = parentIndex;
        this.branchIndex = branchIndex;
    }
}


export class undoStackType {mathFile: MathFileType; pIndex:number; lIndex:number; sIndex:number; 
                            canvasWidth:number; canvasHeight:number; type: string; probState: number; 
                            curProbFracState: number; state: number; whiteSpaceIndex: number; 
                            priorWhiteSpaceSize: WhiteSpaceSize | null = null; noSplit: boolean; branchList: [];
    constructor(mathFile: MathFileType) {
        this.mathFile = mathFile;
        this.pIndex = -1;
        this.lIndex = -1;
        this.sIndex = -1;
        this.canvasWidth = stage.canvas.width;
        this.canvasHeight = stage.canvas.height;
        this.type = UNDO_TYPE_FILE;
        this.probState = STATE_NORMAL;
        this.curProbFracState = STATE_NORMAL;
        this.state = STATE_NORMAL;  // needed to detect if in draw tool
        this.whiteSpaceIndex = 0;
        this.priorWhiteSpaceSize = null;
        this.noSplit = false;
        //this.branchID = -1;
        this.branchList = [];
    }
}

// object class for the user UI clicks to position white space
export class WhiteSpaceSelector{startY:number; endY: number;
    constructor() {
    this.startY = 0;
    this.endY = 0; 
    }
}

// whitespace descriptor class for the save file json and for calculaing repetitive splits
export class WhiteSpaceSize{startY:number; height: number; originalImgIndex: number; 
                            priorImgIndex: number; imageY: number; addedStartY: number; addedEndY: number; 
    constructor(startY:number, height:number, originalImgIndex: number, 
        priorImgIndex: number, imageY: number) {
    this.startY = startY;       // start of the source Rect Y within original image
    this.height = height;       // height of the source Rect of original image
    this.originalImgIndex = originalImgIndex; 
    this.priorImgIndex = priorImgIndex;
    this.imageY = imageY;         // y coordinate of createjs obj for the corresponding bitmap image
    this.addedStartY = 0;        // Y cursor position of selector start
    this.addedEndY = 0;           // Y cursor position of selector end
    }
}

export const LOG_MATHKEY = "key";
export const LOG_MOUSE = "stage click";
export const LOG_KEYBOARD = "KB";
export const LOG_CNTR = "cntr";


// The following data structures are used for creating bug tracing reports.  They may be used for undo also
// The are converted to a json to be given for bugs
export class CanvasInput {
    t: string; data: string;
    constructor(t: string, data: string) {
        this.t = t;
        this.data = data;
    }
}


export class UserInputLog {
    mathLevel: number; startFontSize: number; input: CanvasInput[];
    constructor(mathLevel: number, startFontSize: number) {
        this.mathLevel = mathLevel;
        this.startFontSize = startFontSize;
        this.input = [];
    }
}
/* colors to save
 export const CV_COLOR_11 = "#96ADFC";  // blue
 export const CV_COLOR_12 = "#DBE1F1";  // blue-grey
 export const CV_COLOR_13 = "#F8F0F3"; //"#F5F5F5";  // off white
 
 export const CV_COLOR_3=  "#F8FD89"; // yellow
 export const CV_COLOR_5 = "#A5F7E1"; // turquoise
 export const CV_COLOR_9 = "#B987DC";  // purple
 export const CV_COLOR_10 = "#A8F29A";   // green
 export const CV_COLOR_7 = "#E0A6AA";   //red
 */

export const FONT_DEFAULT = "Verdana";              // Standard display font
export const FONT_WITH_BOLD = "Lato";
export const FONT_ALT = "open-dyslexic";             // user option font for display
export const FONT_MATH = "Cambria Math";      // Used for operators,some misc symbals
export const FONT_SPEC_1 = "Cambria";
export const FONT_ITALIC = "Italic ";
export const FONT_SPEC_2 = "Calibri";
export const FONT_WINGDINGS = "Wingdings";
export const FONT_GEO_NOTO = "KiwiGeometryNoto";
export const FONT_GEO_DEJAVU = "KiwiGeometryDejaVu";
export const CV_BACKGROUND_COLOR = "rgb(255,253,253)";

// Define "states" for canvas db logic
//export const STATE_NORMAL = 1;
//export const STATE_IN_TEXTBOX = 2;

export const KEY_CODE_SHIFT = 16;
export const KEY_CODE_DELETE = 46;
export const KEY_CODE_BACKSPACE = 8;
export const KEY_CODE_ENTER = 13;

// FONT_INDEX determines the indexex into SIZE to use for fonts, to determine the font size from user pref from 0-3  
// this size can be further changed by the user menu item of font increase/decrease
// IMPORTANT - THESE NEED CHANGING if any elements added to SIZE
//export const FONT_INDEX = [3,5,8,11];
export const FONT_INDEX = [4, 6, 9, 12];
export const FONT_INDEX_MIN = 0;
export const FONT_INDEX_MAX = 19;


// DRAW_SIZE defines size of fonts and symbol grid within
// an array, which will be indexed by  FONT_SIZE_SM, FONT_SIZE_MED or
// FONT_SIZE_LARGE.  Font size will eventually be selected based on 
// user preferences setting of small, medium, or large
// medium is the default

// The canvas math display determines the location to draw
// symbols based on an internal grid system, with the unit size
// for one character defined below as gridWidth and gridHeight. 
// Createjs object sizes can be transformed by Scale operations 

export const SIZE =
    [
        {   // constants for font increment
            font: 8,     // Standard display font
            gridWidth: 9.5, //10.5,
            gridHeight: 14,
            altHeight: 9.5,
        },
        {   // constants font increment
            font: 10,     // Standard display font
            gridWidth: 11.5, // 13,
            gridHeight: 17.5,
            altWidth: 11.5,
        },
        {   // constants font size 
            font: 12,     // Standard display font
            gridWidth: 14, //16,
            gridHeight: 21,
            altWidth: 14,
        },
        {   // constants font increment - size small
            font: 14,     // Standard display font
            gridWidth: 16.5, //18.5,
            gridHeight: 24.5,
            altWidth: 16.5,
        },
        {   // constants font increment
            font: 16,     // Standard display font
            gridWidth: 19, //21,
            gridHeight: 28,
            altWidth: 19,
        },

        {  // constants for font size medium - element 5
            font: 18,
            gridWidth: 21, //24,
            gridHeight: 32,
            altWidth: 21,
        },

        {   // constants font increment
            font: 20,     // Standard display font
            gridWidth: 23.5, //26.5,
            gridHeight: 35,
            altWidth: 23.5,
        },
        {   // constants font increment
            font: 22,     // Standard display font
            gridWidth: 26, //30,
            gridHeight: 38.5,
            altWidth: 26,
        },

        {   // constants for font size large - element 8 
            font: 24,
            gridWidth: 28, //32,
            gridHeight: 42,
            altWidth: 28,
        },
        {   // constants font increment
            font: 26,     // Standard display font
            gridWidth: 30.5, //34.5,
            gridHeight: 45,
            altWidth: 30.5,
        },
        {   // constants font increment
            font: 28,     // Standard display font
            gridWidth: 33, //37,
            gridHeight: 49,
            altWidth: 33,
        },
        {   // constants for font size extra large - element 11
            font: 32,
            gridWidth: 37.5, //42,
            gridHeight: 56,
            altWidth: 37.5,

        },
        {   // constants font increment
            font: 36,     // Standard display font
            gridWidth: 42, //48,
            gridHeight: 63,
            altWidth: 42,

        },
        {   // constants font increment
            font: 40,     // Standard display font
            gridWidth: 46, //53,
            gridHeight: 70,
            altWidth: 34,
        },
        {   // constants font increment
            font: 44,     // Standard display font
            gridWidth: 50,//58.5,
            gridHeight: 52,
            altWidth: 58.5,
        },
        {   // constants font increment
            font: 48,     // Standard display font
            gridWidth: 56.5, //64,
            gridHeight: 84,
            altWidth: 56.5,
        },

        {   // constants font increment
            font: 52,     // Standard display font
            gridWidth: 61, //70,
            gridHeight: 91,
            altWidth: 61,
        },
        {   // constants font increment
            font: 56,     // Standard display font
            gridWidth: 66, //74.5,
            gridHeight: 98,
            altWidth: 66,
        },
        {   // constants font increment
            font: 60,     // Standard display font
            gridWidth: 70, //80,
            gridHeight: 105,
            altWidth: 70,
        },
        {   // constants font increment
            font: 64,     // Standard display font
            gridWidth: 75, //85,
            gridHeight: 112,
            altWidth: 75,
        },

    ]

export interface IFormSelection {
    value: number | boolean;
    title: string;
}

export const FONT_SPACING_ITEMS: IFormSelection[] = [
    {
        value: 1,
        title: 'preferencesModalFontSpacingOptionOne'
    },
    {
        value: 2,
        title: 'preferencesModalFontSpacingOptionTwo'
    },
    {
        value: 3,
        title: 'preferencesModalFontSpacingOptionThree'
    },
];

